/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Privacy_Setting_Enum =
  | 'CONTRACTUALIZED'
  | 'EVERYONE'
  | 'NOBODY';

export type UpdateUserContactInformationMutationVariables = Exact<{
  userId: string;
  mobile_phone?: string | null | undefined;
  mobile_privacy_setting?: Types.Privacy_Setting_Enum | null | undefined;
  landline_phone?: string | null | undefined;
  landline_privacy_setting?: Types.Privacy_Setting_Enum | null | undefined;
  email_privacy_setting?: Types.Privacy_Setting_Enum | null | undefined;
}>;


export type UpdateUserContactInformationMutation = { update_user_by_pk: { id: string } | null };


export const UpdateUserContactInformationDocument = /*#__PURE__*/ gql`
    mutation UpdateUserContactInformation($userId: uuid!, $mobile_phone: String, $mobile_privacy_setting: privacy_setting_enum, $landline_phone: String, $landline_privacy_setting: privacy_setting_enum, $email_privacy_setting: privacy_setting_enum) {
  update_user_by_pk(
    pk_columns: {id: $userId}
    _set: {mobile_phone: $mobile_phone, mobile_privacy_setting: $mobile_privacy_setting, landline_phone: $landline_phone, landline_privacy_setting: $landline_privacy_setting, email_privacy_setting: $email_privacy_setting}
  ) {
    id
  }
}
    `;
export type UpdateUserContactInformationMutationFn = Apollo.MutationFunction<UpdateUserContactInformationMutation, UpdateUserContactInformationMutationVariables>;

/**
 * __useUpdateUserContactInformationMutation__
 *
 * To run a mutation, you first call `useUpdateUserContactInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserContactInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserContactInformationMutation, { data, loading, error }] = useUpdateUserContactInformationMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      mobile_phone: // value for 'mobile_phone'
 *      mobile_privacy_setting: // value for 'mobile_privacy_setting'
 *      landline_phone: // value for 'landline_phone'
 *      landline_privacy_setting: // value for 'landline_privacy_setting'
 *      email_privacy_setting: // value for 'email_privacy_setting'
 *   },
 * });
 */
export function useUpdateUserContactInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserContactInformationMutation, UpdateUserContactInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserContactInformationMutation, UpdateUserContactInformationMutationVariables>(UpdateUserContactInformationDocument, options);
      }
export type UpdateUserContactInformationMutationHookResult = ReturnType<typeof useUpdateUserContactInformationMutation>;
export type UpdateUserContactInformationMutationResult = Apollo.MutationResult<UpdateUserContactInformationMutation>;
export type UpdateUserContactInformationMutationOptions = Apollo.BaseMutationOptions<UpdateUserContactInformationMutation, UpdateUserContactInformationMutationVariables>;